import { toast } from 'react-hot-toast';
import { api } from '../../services/authService';

const createCallOutcomeSlice = (set, get) => ({
    // State
    callOutcomes: [],
    currentOutcome: null,
    isLoading: false,
    error: null,
    pagination: {
        page: 1,
        limit: 20,
        total: 0,
        pages: 0
    },

    // Actions
    setLoading: (loading) => set({ isLoading: loading }),

    setError: (error) => set({ error }),

    clearError: () => set({ error: null }),

    // Kapanış kodu oluştur
    createCallOutcome: async (outcomeData) => {
        try {
            set({ isLoading: true, error: null });

            // Token kontrolü ekle
            const { token } = get();
            if (!token) {
                const errorMessage = 'Oturum bulunamadı. Lütfen tekrar giriş yapın.';
                set({ error: errorMessage });
                return {
                    success: false,
                    error: errorMessage
                };
            }

            const response = await api.post('call-outcomes', outcomeData);

            if (response.data.success) {
                // Mevcut outcome'u güncelle
                set({ currentOutcome: response.data.data });

                return {
                    success: true,
                    data: response.data.data
                };
            } else {
                throw new Error(response.data.error || 'Kapanış kodu kaydedilemedi');
            }
        } catch (error) {
            const errorMessage = error.response?.data?.error || error.message || 'Bir hata oluştu';
            set({ error: errorMessage });

            return {
                success: false,
                error: errorMessage
            };
        } finally {
            set({ isLoading: false });
        }
    },

    // Session ID'ye göre kapanış kodu getir
    getCallOutcomeBySession: async (sessionId) => {
        try {
            set({ isLoading: true, error: null });

            const response = await api.get(`call-outcomes/${sessionId}`);

            if (response.data.success) {
                set({ currentOutcome: response.data.data });
                return {
                    success: true,
                    data: response.data.data
                };
            } else {
                throw new Error(response.data.error || 'Kapanış kodu bulunamadı');
            }
        } catch (error) {
            const errorMessage = error.response?.data?.error || error.message || 'Bir hata oluştu';
            set({ error: errorMessage });

            return {
                success: false,
                error: errorMessage
            };
        } finally {
            set({ isLoading: false });
        }
    },

    // Kapanış kodlarını listele
    listCallOutcomes: async (filters = {}) => {
        try {
            set({ isLoading: true, error: null });

            const params = new URLSearchParams();

            // Filtreleri ekle
            Object.keys(filters).forEach(key => {
                if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
                    params.append(key, filters[key]);
                }
            });

            const response = await api.get(`call-outcomes?${params.toString()}`);

            if (response.data.success) {
                set({
                    callOutcomes: response.data.data,
                    pagination: response.data.pagination
                });

                return {
                    success: true,
                    data: response.data.data,
                    pagination: response.data.pagination
                };
            } else {
                throw new Error(response.data.error || 'Kapanış kodları listelenemedi');
            }
        } catch (error) {
            const errorMessage = error.response?.data?.error || error.message || 'Bir hata oluştu';
            set({ error: errorMessage });

            return {
                success: false,
                error: errorMessage
            };
        } finally {
            set({ isLoading: false });
        }
    },

    // Kapanış kodunu güncelle
    updateCallOutcome: async (id, updateData) => {
        try {
            set({ isLoading: true, error: null });

            const response = await api.put(`call-outcomes/${id}`, updateData);

            if (response.data.success) {

                // Mevcut outcome'u güncelle
                set({ currentOutcome: response.data.data });

                // Listeyi de güncelle
                const { callOutcomes } = get();
                const updatedList = callOutcomes.map(outcome =>
                    outcome.id === id ? response.data.data : outcome
                );
                set({ callOutcomes: updatedList });

                return {
                    success: true,
                    data: response.data.data
                };
            } else {
                throw new Error(response.data.error || 'Kapanış kodu güncellenemedi');
            }
        } catch (error) {
            const errorMessage = error.response?.data?.error || error.message || 'Bir hata oluştu';
            set({ error: errorMessage });

            return {
                success: false,
                error: errorMessage
            };
        } finally {
            set({ isLoading: false });
        }
    },

    // İstatistikleri getir
    getCallOutcomeStats: async (filters = {}) => {
        try {
            set({ isLoading: true, error: null });

            const params = new URLSearchParams();

            // Filtreleri ekle
            Object.keys(filters).forEach(key => {
                if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
                    params.append(key, filters[key]);
                }
            });

            const response = await api.get(`call-outcomes/stats?${params.toString()}`);

            if (response.data.success) {
                return {
                    success: true,
                    data: response.data.data
                };
            } else {
                throw new Error(response.data.error || 'İstatistikler alınamadı');
            }
        } catch (error) {
            const errorMessage = error.response?.data?.error || error.message || 'Bir hata oluştu';
            set({ error: errorMessage });

            return {
                success: false,
                error: errorMessage
            };
        } finally {
            set({ isLoading: false });
        }
    },

    // State'i temizle
    clearCallOutcomes: () => {
        set({
            callOutcomes: [],
            currentOutcome: null,
            isLoading: false,
            error: null,
            pagination: {
                page: 1,
                limit: 20,
                total: 0,
                pages: 0
            }
        });
    },

    // Mevcut outcome'u temizle
    clearCurrentOutcome: () => {
        set({ currentOutcome: null });
    },

    // Kapanış kodu seçenekleri
    outcomeOptions: [
        {
            value: 'approved',
            label: 'Onaylandı',
            color: 'success',
            icon: '✓',
            description: 'Kimlik doğrulama başarılı'
        },
        {
            value: 'failed',
            label: 'Başarısız',
            color: 'warning',
            icon: '⚠',
            description: 'Kimlik doğrulama başarısız'
        },
        {
            value: 'rejected',
            label: 'Reddedildi',
            color: 'error',
            icon: '✗',
            description: 'Kimlik doğrulama reddedildi'
        }
    ],

    // Kapanış kodu seçeneğini getir
    getOutcomeOption: (code) => {
        const { outcomeOptions } = get();
        return outcomeOptions.find(option => option.value === code);
    }
});

export default createCallOutcomeSlice; 
